import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import type { BillingPlanTier } from '@recruitee/products-types';
import { RtTooltip, BadgeComponent, HeadingComponent } from '@recruitee/user-interface';

import { ProductNamePipe } from '../../product-name/product-name.pipe';
import { PlanPickerProductDescriptionPipe } from '../plan-picker-product-description.pipe';

@Component({
  selector: 'rt-plan-picker-product-header',
  templateUrl: './plan-picker-product-header.component.html',
  styleUrls: ['./plan-picker-product-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    HeadingComponent,
    BadgeComponent,
    RtTooltip,
    ProductNamePipe,
    TranslatePipe,
    TitleCasePipe,
    PlanPickerProductDescriptionPipe,
  ],
})
export class PlanPickerProductHeaderComponent {
  @Input() public codename: BillingPlanTier;
  @Input() public showCustomBadge: boolean;
  @Input() public showTrialPlanBadge: boolean;
}
